<template>
  <section class="statistics-section" :class="{ 'variant-light': variant === 'light' }">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-6 mb-4">
          <div class="stat-card animate-on-scroll fade-in-up">
            <div class="stat-number">{{ members }}</div>
            <div class="stat-label">Miembros</div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 mb-4">
          <div class="stat-card animate-on-scroll fade-in-up" style="animation-delay: 0.1s">
            <div class="stat-number">{{ years }}</div>
            <div class="stat-label">Años de servicio</div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 mb-4">
          <div class="stat-card animate-on-scroll fade-in-up" style="animation-delay: 0.2s">
            <div class="stat-number">{{ computedClinicsCount }}</div>
            <div class="stat-label">Locaciones de clínicas</div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 mb-4">
          <div class="stat-card animate-on-scroll fade-in-up" style="animation-delay: 0.3s">
            <div class="stat-number">{{ satisfaction }}%</div>
            <div class="stat-label">Pacientes satisfechos</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/**
 * Sección de estadísticas reutilizable.
 * Muestra miembros, años de servicio, locaciones y satisfacción.
 */
export default {
  name: 'StatisticsSection',
  props: {
    members: {
      type: [String, Number],
      default: '500+'
    },
    years: {
      type: [String, Number],
      default: '3+'
    },
    clinicsCount: {
      type: Number,
      default: 0
    },
    locations: {
      type: Array,
      default: null
    },
    satisfaction: {
      type: [String, Number],
      default: 99
    },
    variant: {
      type: String,
      default: 'default',
      validator: (v) => ['default', 'light'].includes(v)
    }
  },
  computed: {
    computedClinicsCount() {
      if (this.locations && Array.isArray(this.locations)) {
        return this.locations.length;
      }
      return this.clinicsCount;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/variables';

.statistics-section {
  padding: 80px 0;
  background: linear-gradient(135deg, #0d2b45 0%, #22cfe0 100%);

  .stat-card {
    text-align: center;
    padding: 2rem;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 15px;
    transition: all 0.3s ease;
    border: 2px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0 5px 20px rgba(13, 43, 69, 0.1);

    &:hover {
      transform: translateY(-5px);
      background: white;
      border-color: rgba(255, 255, 255, 0.5);
      box-shadow: 0 10px 30px rgba(13, 43, 69, 0.15);
    }

    .stat-number {
      font-size: 4rem;
      font-weight: 700;
      color: #2D4A4D;
      line-height: 1;
      margin-bottom: 0.5rem;
    }

    .stat-label {
      font-size: 1.3rem;
      color: #2D4A4D;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 1px;
    }
  }
}

.statistics-section.variant-light {
  background: $landing-primary-gradient;

  .stat-card {
    background: rgba(255, 255, 255, 0.18);
    border: 3px solid rgba(255, 255, 255, 0.25);
    backdrop-filter: blur(15px);

    &:hover {
      background: rgba(255, 255, 255, 0.28);
      border-color: rgba(255, 255, 255, 0.5);
    }

    .stat-number {
      color: white;
      text-shadow: 0 3px 12px rgba(45, 106, 110, 0.3);
    }

    .stat-label {
      color: rgba(255, 255, 255, 0.98);
    }
  }
}

@media (max-width: 991px) {
  .statistics-section {
    padding: 60px 0;

    .stat-card .stat-number {
      font-size: 3rem;
    }

    .stat-card .stat-label {
      font-size: 1.1rem;
    }
  }
}

@media (max-width: 768px) {
  .statistics-section {
    padding: 50px 0;

    .stat-card .stat-number {
      font-size: 2.5rem;
    }
  }
}
</style>
